import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable()
export class EmailSmsDataService {
    constructor() {
    }

    public notificationType;
    setNotificationType(type){
        this.notificationType = type
    }
    getNotificationType(){
        return this.notificationType
    }

    public templateId;
    setTemplateId(id){
        this.templateId = id;
    }
    getTemplateId(){
        return this.templateId;
    }

    public isDefaultTemplateName: any = '';
    public isDefaultTemplateNameSubmissionObservable = new BehaviorSubject(this.isDefaultTemplateName);
  
    changeDefaultTemplateNameSubmission() {
        this.isDefaultTemplateNameSubmissionObservable.next(this.isDefaultTemplateName);
    }

    public isTemplateName: any = '';
    public isTemplateNameSubmissionObservable = new BehaviorSubject(this.isTemplateName);
  
    changeTemplateNameSubmission() {
        this.isTemplateNameSubmissionObservable.next(this.isTemplateName);
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/email-sms-data.service.ts